import React from "react";
import { Link } from "./PageLink";

interface Props {
  heading: string;
  body?: string;
}

const CTABand: React.FC<Props> = ({ heading, body }) => (
  <section className="cta-band" data-testid="cta-band">
    <div className="container">
      <h2>{heading}</h2>
      {body && <p>{body}</p>}
      <div className="cta-band-actions">
        <Link to="/contact" className="btn" data-testid="link-cta-contact">Request a Consultation</Link>
        <a href="tel:+15084500490" className="btn btn-outline" data-testid="link-cta-phone">Call 508-450-0490</a>
      </div>
    </div>
  </section>
);

export default CTABand;
